import React from 'react';
import R from 'ramda';
import { connect } from 'react-redux';
import * as steps from 'common/steps';
import { getActiveStep, getLoading } from 'submission/submissionReducer';
import ContactInfo from 'contact-info/components/ContactInfo';
import DissertationInfo from 'dissertation-info/components/DissertationInfo';
import FileUpload from 'file-upload/components/FileUpload';
import Introduction from 'introduction/components/Introduction';
import LoadingPanel from 'general-components/LoadingPanel';
import Options from 'options/components/Options';
import Review from 'review/components/Review';
import CancelSubmissionDialog from './CancelSubmissionDialog';
import InvalidSubmissionDialog from './InvalidSubmissionDialog';
import SubmissionErrorDialog from './SubmissionErrorDialog';
import SubmissionPanelHeader from './SubmissionPanelHeader';
import SubmissionPanelMenu from './SubmissionPanelMenu';
import UploadDialog from './UploadDialog';
import ValidationErrorsDialog from './ValidationErrorsDialog';
import styles from './SubmissionPanel.css';

const getStep = step => {
  switch (step) {
    case steps.INTRODUCTION:
      return <Introduction />;

    case steps.OPTIONS:
      return <Options />;

    case steps.CONTACT_INFO:
      return <ContactInfo />;

    case steps.DISSERTATION_INFO:
      return <DissertationInfo />;

    case steps.FILE_UPLOAD:
      return <FileUpload />;

    case steps.REVIEW:
      return <Review />;

    default:
      return <h1>Unknown Step</h1>;
  }
};

const SubmissionPanel = ({ activeStep, loading }) =>
  loading
    ? <LoadingPanel message="Loading submission data..." />
    : <div className={styles.panel}>
        <div className={styles.headerContainer}>
          <SubmissionPanelHeader />
        </div>
        <div className={styles.body}>
          <div className={styles.menuContainer}>
            <SubmissionPanelMenu />
          </div>
          <div className={styles.panelContainer} role="main">
            {getStep(activeStep)}
          </div>
        </div>
        <CancelSubmissionDialog />
        <InvalidSubmissionDialog />
        <UploadDialog />
        <ValidationErrorsDialog />
        <SubmissionErrorDialog />
      </div>;

const mapState = R.pipe(
  R.path(['submission']),
  R.applySpec({
    activeStep: getActiveStep,
    loading: getLoading,
  }),
);

export default connect(mapState)(SubmissionPanel);



// WEBPACK FOOTER //
// ./src/submission/components/SubmissionPanel.js